module.exports = __webpack_public_path__ + "static/media/try.de9696a5.svg";